import styles from "./Options.module.scss";
import { FC, lazy, Suspense } from "react";
import { withStockStamp } from "@/components/stock-stamp-hoc/StockStampHOC";
import { Box, CircularProgress, Typography } from "@mui/material";
const MUILineChart = lazy(() => import("@/components/line-chart/MUILineChart"));
interface PropsTypes {
    row?: any;
    ts: number[];
    valueCss: string;
    month: number;
    mobile?: boolean;
    plotLines?: number;
    overviewPage?: boolean;
    obfuscated?: boolean;
}

const Options: FC<PropsTypes> = ({ row, ts, valueCss, month, mobile, plotLines, overviewPage, obfuscated = false }) => {
    return overviewPage ? (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Typography sx={{ height: "40%" }} variant={mobile ? "h2" : "moduleContentTitle"} component={mobile ? "div" : "span"} className={valueCss}>
                <Box sx={{ lineHeight: 1 }}>
                    <Typography variant="subtitle2" component="div" style={{ color: "var(--text-3, #8a8f97)", textTransform: "initial" }}>
                        PUT/CALL Ratio
                    </Typography>
                </Box>
                {Number(month).toFixed(2)}
            </Typography>

            <Box sx={{ height: "60%" }}>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={ts} id={row && row.stock.ticker + row.options.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} obfuscated={obfuscated} />
                </Suspense>
            </Box>
        </Box>
    ) : (
        <div className={styles.Options}>
            <Typography variant={mobile ? "h2" : "moduleContentTitle"} component={mobile ? "div" : "span"} className={valueCss}>
                <Box sx={{ lineHeight: 1, pb: 1 }}>
                    <Typography variant="subtitle2" component="div" style={{ color: "var(--text-3, #8a8f97)", textTransform: "initial" }}>
                        PUT/CALL Ratio
                    </Typography>
                </Box>
                {Number(month).toFixed(2)}
            </Typography>
            <Box>
                <Suspense
                    fallback={
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <CircularProgress size={30} />
                        </div>
                    }
                >
                    <MUILineChart data={ts} id={row && row.stock.ticker + row.options.box_name} labels={["-3m", "-2m", "-1m"]} labelsAlign={"left"} optionsLine={row && row?.options?.["1y_50_pct"]} obfuscated={obfuscated} />
                </Suspense>
            </Box>
        </div>
    );
};

export default withStockStamp(Options, "month", { title: "Options" });
